import { FullBusinessPost, calcDateSpanDescription } from 'model';
// eslint-disable-next-line css-modules/no-unused-class
import { IonRouterLink } from '@ionic/react';
import { useGetBusinessQuery } from '../api/BusinessApi';
import GenericBusinessIcon from '../assets/buildingIcon.png';
import { useCurrentUser } from '../hooks/useCurrentUser';
import { getBusinessImages } from '../util/getBusinessImages';
import { getInitials } from '../util/initials';

import { PostMenu } from './PostMenu';
import { PostTypeIcon } from './PostTypeIcon';
import { ProfileImage } from './ProfileImage';
import { SkeletonLoader } from './SkeletonLoader';
import { TopicButton } from './TopicButton';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './PostHeader.module.css';
import { useCallback } from 'react';
import { useTrackPostViewMutation } from '../api/PostApi.js';
import { useOnElementEntersView } from '../hooks/useOnElementEntersView.js';
export interface BusinessPostHeaderProps {
	post: FullBusinessPost;
	detail?: boolean;
	compact?: boolean;
}

export function BusinessPostHeader({ post, detail = false, compact = false }: BusinessPostHeaderProps): JSX.Element {
	const { businessId } = post;
	const { data: business } = useGetBusinessQuery(businessId, {
		skip: businessId === ''
	});
	const { logo = GenericBusinessIcon } = business ? getBusinessImages(business) : {};
	const user = useCurrentUser();
	const [trackView] = useTrackPostViewMutation();
	const ref = useOnElementEntersView(
		useCallback(() => {
			trackView({ postId: post._id });
		}, [post._id, trackView]),
		0.9, // 90% of the element is visible
		true // only fire one time
	);
	return (
		<>
			<div className={styles.PostHeader} data-testid={`PostHeader-${post._id}`} ref={ref}>
				<div className={styles.authorImage}>
					<SkeletonLoader height={''}>
						{business === undefined ? null : (
							<IonRouterLink routerLink={`/main/bus/show/${post.businessId}`}>
								<ProfileImage
									size="small"
									url={logo}
									text={getInitials(business.name)}
									background={
										business.logoBackgroundColor ? business.logoBackgroundColor : 'transparent'
									}
									shape="square"
									contain
								/>
							</IonRouterLink>
						)}
					</SkeletonLoader>
				</div>
				<div className={styles.details}>
					<div className={styles.row}>
						<div className={styles.name}>
							<SkeletonLoader>{business === undefined ? null : business.name}</SkeletonLoader>
						</div>
						{!compact && <PostMenu post={post} userid={user._id} />}
					</div>
					<div className={styles.row}>
						<span className={styles.typeDate}>
							<PostTypeIcon postType={post.postType} />
							<time>{calcDateSpanDescription(post.updated)}</time>
						</span>
						{!compact && post.topic && (
							<TopicButton topic={post.topic} testId={`TopicButton-${post._id}`} />
						)}
					</div>
				</div>
			</div>
		</>
	);
}
